export const titlesEn = {
  alerts: 'Alerts',
  invoices: 'Invoice',
  withdrawals: 'Withdrawals',
  authorization: 'Authorization',
  login: 'Login',
  forgotPassword: 'Forgot your password?',
  recovery: 'Authorization',
  analytics: 'Analytics',
  withdraw: 'Withdraw',
  payments: 'Payments',
  reports: 'Reports',
  settings: 'Settings',
  payment: 'Payment details',
  fasterPayouts: 'Payouts FPS',
  fasterPayments: 'Payments FPS',
  fasterPayout: 'Payment details FPS',
  makeFasterPayout: 'Make a payout FPS',
  apmPayments: 'Payments APM',
  cryptoPayments: 'Crypto Payments',
  notFound: 'Page not found',
  paymentSessionDetails: 'Payment session details',
  errorPage: 'Error',
  returns: 'Returns',
} as const;

type TTitlesEnKeys = keyof typeof titlesEn;

export const titlesRu = {
  alerts: 'Оповещения',
  invoices: 'Выставить счет',
  withdrawals: 'Выплаты',
  authorization: 'Авторизация',
  login: 'Войти в личный кабинет',
  forgotPassword: 'Забыли пароль?',
  recovery: 'Авторизация',
  analytics: 'Аналитика',
  withdraw: 'Сделать выплату',
  payments: 'Платежи',
  reports: 'Отчеты',
  settings: 'Настройки',
  payment: 'Данные платежа',
  fasterPayouts: 'Выплаты СБП',
  fasterPayments: 'Платежи СБП',
  fasterPayout: 'Данные платежа СБП',
  makeFasterPayout: 'Сделать выплату СБП',
  notFound: 'Страница не найдена',
  apmPayments: 'Платежи APM',
  cryptoPayments: 'Платежи Crypto',
  paymentSessionDetails: 'Детализация платёжной сессии',
  errorPage: 'Ошибка',
  returns: 'Возвраты',
} satisfies Record<TTitlesEnKeys, string>;
